import { render } from "./OnboardingEmailSyncOffice365.vue?vue&type=template&id=00c5b168"
import script from "./OnboardingEmailSyncOffice365.vue?vue&type=script&lang=js"
export * from "./OnboardingEmailSyncOffice365.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__